import { fetchAllByEmployer } from 'util/api/job_listings';
import { useEffect, useState } from 'react';
import JobList from './search/list';

export default function SchoolJobsSection({ employer, location }) {
  const [jobs, setJobs] = useState([]);

  useEffect(() => {
    fetchAllByEmployer(employer.id).then((response) => {
      setJobs(response);
    });
  }, [employer]);

  return (
    <div className="px-4 py-4 sm:flex sm:items-center sm:justify-between sm:px-6 lg:px-8">
      <div className="flex-1 min-w-0">
        <h1 className="py-4 pb-8 text-xl font-medium leading-6 text-gray-900 sm:truncate">Jobs</h1>
        <JobList jobs={jobs} Location="School Page" />
      </div>
    </div>
  );
}
